module.exports = __webpack_public_path__ + "static/media/fadedDrongo.55bff789.png";